export default __webpack_public_path__ + "static/discount-modal-729b66d7c76c63e2fedce3ad3a525df9.jpg";